import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { motion } from 'framer-motion';
import * as FaIcons from 'react-icons/fa';

const Bonuses = ({ finishBonuses }) => {

  const Icon = ({ iconName, className }) => {
    const IconComponent = FaIcons[iconName];
    if (!IconComponent) return null;
    return <IconComponent className={className} />;
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="mb-8 mx-4 sm:mx-0"
    >
      {finishBonuses && finishBonuses.map((bonus, index) => (
        <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden border border-blue-100 mb-6">
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-600 to-indigo-700 px-4 py-3 text-white">
            <div className="flex items-center justify-center gap-2">
              <Icon iconName={bonus.header_icon} className="text-yellow-300 text-xl sm:text-2xl" />
              <h3 className="text-lg sm:text-xl font-bold">{bonus.header_title}</h3>
            </div>
          </div>

          {/* Content */}
          <div className="p-4 sm:p-6 bg-gradient-to-br from-blue-50 to-indigo-50">
            {/* Grid Layout for Bonuses */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {bonus.bonuses.map((content, idx) => (
                <motion.div 
                  key={idx}
                  whileHover={{ y: -3 }}
                  className="bg-white p-4 rounded-lg shadow-sm border-l-4 border-indigo-500 flex items-start"
                >
                  <div className="bg-indigo-100 p-2 sm:p-3 rounded-full mr-4 flex-shrink-0">
                    <Icon iconName={content.icon} className="text-indigo-600 text-lg sm:text-xl" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 text-sm sm:text-base mb-1 sm:mb-2">{content.title}</h4>
                    <p className="text-gray-600 text-xs sm:text-sm leading-tight sm:leading-relaxed">
                      
                      <div dangerouslySetInnerHTML={{ __html: content.description }} />
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>

            {/* Motivation Text */}
            <div className="mt-6 px-2 text-center">
              <p className="text-gray-700 text-xs sm:text-sm font-medium flex flex-col sm:flex-row items-center justify-center">
                <span className="flex items-center mb-1 sm:mb-0 sm:mr-2">
                  <FaCheckCircle className="text-green-500 mr-1" />
                  শুধুমাত্র সম্পূর্ণ মাস্টারক্লাসটি দেখলেই
                </span>
                <span>এই বিশেষ বোনাসগুলি পাবেন</span>
              </p>
            </div>
          </div>
        </div>
      ))}
    </motion.div>
  );
};

export default Bonuses;